import { Link } from "react-router-dom";
import { ChevronLeft, Lock, MessageCircle, Phone, Mail } from "lucide-react";
import { SEMAPHORE, waLink } from "@/lib/conecta";

export const BackLink = ({ to, label }) => (
  <Link to={to} data-testid="back-link" className="inline-flex items-center gap-1 text-sm c-text-2 hover:opacity-80"><ChevronLeft className="w-4 h-4" /> {label}</Link>
);

export const SemDot = ({ value, size = "w-3 h-3" }) => (
  <span className={`inline-block rounded-full shrink-0 ${size} ${SEMAPHORE[value]?.dot || "bg-slate-400/40"}`} aria-label={value || "sin semáforo"} />
);

export const PrivateBadge = ({ show }) => (show ? (
  <span data-testid="private-badge" className="inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded border border-[#bc9538]/50 c-accent"><Lock className="w-3 h-3" /> Solo yo</span>
) : null);

const ActionBtn = ({ href, icon: Icon, label, testid, disabled }) => (
  <a href={disabled ? undefined : href} target={href?.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={testid} aria-disabled={disabled}
    className={`flex-1 flex flex-col items-center gap-1 py-3 rounded-xl c-card text-xs font-semibold transition-opacity ${disabled ? "opacity-40 pointer-events-none" : "active:scale-[0.98]"}`}>
    <Icon className="w-5 h-5 c-accent" /> {label}
  </a>
);

export const ShareButtons = ({ phone, whatsapp, email, text }) => (
  <div className="flex gap-2" data-testid="share-buttons">
    <ActionBtn href={waLink(whatsapp || phone, text)} icon={MessageCircle} label="WhatsApp" testid="share-whatsapp-btn" disabled={!(whatsapp || phone) && !text} />
    <ActionBtn href={`tel:${phone || whatsapp}`} icon={Phone} label="Llamar" testid="call-btn" disabled={!(phone || whatsapp)} />
    <ActionBtn href={`mailto:${email}`} icon={Mail} label="Correo" testid="email-btn" disabled={!email} />
  </div>
);
